import { requestWithoutAuth } from '@helpers/request';

export const getPublicSettingsApi = () => requestWithoutAuth('settings');
